import { Box, Button, Card, CardBody, List, Spinner } from "grommet";
import { Outlet, useNavigate } from "react-router-dom";
import { BoxWindow } from "../components/BoxWindow";
import { Currency, Desktop, Money, Monitor, Plan } from "grommet-icons";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { backgrounds } from "grommet-theme-hpe";
import RouletteSVG from "../icons/RouletteSVG";
import SidebarComponent from "../components/layout/SidebarComponent";

export const SettingsPageV2 = () => {

    const { t, i18n, ready } = useTranslation("settings", {
        useSuspense: false,
    });
    const [menuItems] = useState([
        {
            title: "settings:overlaySettingsTitle",
            icon: <Monitor />,
            link: "/settings/overlay-settings",
        },
        {
            title: "settings:donateOptionsTitle",
            icon: <Money />,
            link: "/settings/donate-options",
        },
        {
            title: "settings:paymentMethodsTitle",
            icon: <Currency />,
            link: "/settings/payment-methods",
        },
    ]);

    useEffect(() => {
        console.log(i18n.language);
        
    }, [i18n.language])

    if (!ready) {
        return <Spinner />;
    }

    return (
        <BoxWindow topPadding>
            <Box direction="row" gap={"medium"} fill>
                <Card>
                    <CardBody>
                        <SidebarComponent navs={menuItems} />
                    </CardBody>
                </Card>
                <Box flex>
                    <Outlet />
                </Box>
            </Box>
        </BoxWindow>
    );
};
